// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"15df54b3","406":"c12955db","559":"2043e117","626":"f44f3c5f"}[chunkId] + ".chunk.js";
};